import { actions } from 'data'
import { ModalOrigin } from 'data/types'

export const showDepositModal = (dispatch) => {
  dispatch(actions.deposit.open({ origin: ModalOrigin.BALANCE }))
}

export const showWithdrawalModal = (dispatch) => {
  dispatch(actions.app.showModal('WITHDRAWAL', { origin: ModalOrigin.BALANCE }))
}
